import downArrow from '@/assets/images/advertisement/icons/down-blue-arrow.svg'
import batIcon from '@/assets/images/icon/batIcon.svg'
import CustomLink from '@/shared/components/customLink'
import { getSlugUrl } from '@/shared/utils'
import MyImage from '../../myImage'

type captainWicketKeeper = {
  iPlayerId?: string
  sRoleStr?: string
}

type pagePropsType = {
  batter: any
  table: any
  capwk: any
  expendId: any
  setExpendId: any
  isActiveBatter?: boolean
}

const BatterDataRow = ({
  batter,
  table,
  capwk,
  setExpendId,
  expendId,
  isActiveBatter
}: pagePropsType) => {
  const player = batter?.oBatter
  const playerSlug = player?.oSeo?.sSlug

  function handleTeamForm(id: string) {
    if (expendId === id) {
      setExpendId('')
    } else {
      setExpendId(id)
    }
  }

  const playerName = (
    <>
      {player?.sFullName || player?.sShortName}
      {player?.isCaptain && <span className="ps-1">(c)</span>}
      {player?.isWk && <span className="ps-1">(wk)</span>}
      {player?.bImpactPlayer && (
        <span className="px-0.5 bg-green-600 text-[10px] rounded-sm text-white leading-4">IMP</span>
      )}
    </>
  )

  return (
    <>
      <tr className={`${batter.highlight ? 'highlight' : ''}`}>
        <td className="!w-full max-w-14" width={90}>
          <span className="grid grid-cols-1 sm:grid-cols-2 gap-2">
            <span
              className={`flex items-center  ${batter?.eDismissal === null ? 'text-primary-500-400' : ''}`}
            >
              {batter?.oBatter?.eTagStatus === 'a' ? (
                <>
                  <span className="hidden sm:block">
                    {playerSlug ? (
                      <CustomLink
                        href={getSlugUrl(`/${playerSlug}`)}
                        prefetch={false}
                        className="flex items-center gap-2 w-fit"
                      >
                        {playerName}
                      </CustomLink>
                    ) : (
                      <span className="flex items-center gap-2 w-fit">{playerName}</span>
                    )}
                  </span>
                </>
              ) : (
                <span className="hidden sm:flex items-center gap-2 w-fit">{playerName}</span>
              )}
              {player?.eTagStatus === 'a' ? (
                <>
                  <span className="flex items-center sm:hidden overflow-hidden text-ellipsis">
                    {playerSlug ? (
                      <CustomLink
                        href={getSlugUrl(`/${playerSlug}`)}
                        className="text-sm"
                        prefetch={false}
                      >
                        {playerName}
                      </CustomLink>
                    ) : (
                      <span>{playerName}</span>
                    )}
                    {/* {capwk?.map(
                      (p: captainWicketKeeper, i: number) =>
                        p?.iPlayerId === batter?.iBatterId &&
                        p?.sRoleStr === 'cap' && (
                          <span key={i} className='ps-1'>
                            (c)
                          </span>
                        )
                    )} */}
                    {/* {capwk?.map(
                      (p: captainWicketKeeper, i: number) =>
                        p?.iPlayerId === batter?.iBatterId &&
                        p?.sRoleStr === 'wk' && (
                          <span key={i} className='ps-1'>
                            (Wk)
                          </span>
                        )
                    )} */}
                    {capwk?.map(
                      (p: captainWicketKeeper, i: number) =>
                        p?.iPlayerId === batter?.iBatterId &&
                        p?.sRoleStr === 'wkcap' && (
                          <span key={i} className="ps-1">{`(${'c & wk'})`}</span>
                        )
                    )}
                  </span>
                </>
              ) : (
                <span className=" sm:hidden flex items-center">
                  {player?.sShortName || player?.sFullName}
                  {capwk?.map(
                    (p: captainWicketKeeper, i: number) =>
                      p?.iPlayerId === batter?.iBatterId &&
                      p?.sRoleStr === 'cap' && (
                        <span key={i} className="ps-1">
                          (c)
                        </span>
                      )
                  )}
                  {capwk?.map(
                    (p: captainWicketKeeper, i: number) =>
                      p?.iPlayerId === batter?.iBatterId &&
                      p?.sRoleStr === 'wk' && <span key={i} className="ps-1">{`(Wk)`}</span>
                  )}
                  {capwk?.map(
                    (p: captainWicketKeeper, i: number) =>
                      p?.iPlayerId === batter?.iBatterId &&
                      p?.sRoleStr === 'wkcap' && (
                        <span key={i} className="ps-1">{`(${'c & wk'})`}</span>
                      )
                  )}
                </span>
              )}
              {isActiveBatter ? (
                <div className="ml-1.5 w-4">
                  <MyImage src={batIcon} alt="*" height={16} width={16} />
                </div>
              ) : null}
              {batter?.oCommentary?.sComSummary && (
                <span className="flex-shrink-0" onClick={() => handleTeamForm(batter?.iBatterId)}>
                  <MyImage
                    src={downArrow}
                    className={`h-4 w-4 block !m-0 cursor-pointer !ml-1 dark:brightness-[1] brightness-0 transition-transform duration-300 ${
                      expendId === batter?.iBatterId && 'rotate-180'
                    }`}
                  />
                </span>
              )}
            </span>
            <span
              className={` ${!batter?.eDismissal === null ? 'text-primary-500-400' : 'text-t-light-400'}`}
            >
              {batter?.eDismissal === null ? (
                'not out'
              ) : (
                <span className="flex items-center w-full text-xs">
                  <span onClick={() => handleTeamForm(batter?.iBatterId)} className="">
                    <MyImage
                      src={downArrow}
                      className={`h-4 w-4 hidden md:h-6 md:w-6 !m-0 cursor-pointer  transition-transform duration-300 ${
                        expendId === batter?.iBatterId && 'rotate-180'
                      }`}
                    />
                  </span>
                  <span className="whitespace-pre-wrap break-words">{batter?.sHowOut}</span>
                </span>
              )}
            </span>
          </span>
        </td>
        {Object.keys(table.current)?.map((value, index) => {
          return (
            <td
              className={`align-top !text-right   ${index === 0 ? '!text-textOffWhite' : '!text-textDselected'} `}
              key={index}
            >
              {batter[value]}
            </td>
          )
        })}
      </tr>
      {batter?.eDismissal !== null && expendId === batter?.iBatterId && (
        <>
          <tr className="">
            <td colSpan={6}>
              <div className="relative max-w-screen flex items-start justify-start gap-3">
                <div className="flex flex-col items-center justify-center gap-2">
                  <span className={` font-bold`}>
                    {batter?.oCommentary?.sOver}
                    {batter?.oCommentary?.sBall && '.' + batter?.oCommentary?.sBall}
                  </span>
                  <span
                    className={`${'my-0 mx-4 py-0.5 px-1.5 min-w-[24px] h-6 text-xs leading-5 lg:mx-2.5 md:mb-1  md:min-w-[24px] md:h-6'} rounded-full bg-WicketBg border-WicketBg text-white`}
                  >
                    W
                  </span>
                </div>
                <div className="md:flex-row flex flex-col text-xs md:text-base break-words w-full">
                  <div className="flex flex-col justify-center items-start">
                    <span className="text-textOffWhite block md:hidden whitespace-pre-wrap">
                      {batter?.oCommentary?.sComSummary}
                    </span>
                    <span className="text-textDselected hidden md:block whitespace-pre-wrap">
                      {batter?.oCommentary?.sComSummary}
                    </span>
                    <span
                      className="text-textDselected whitespace-pre-wrap"
                      dangerouslySetInnerHTML={{ __html: batter?.oCommentary?.sText }}
                    ></span>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </>
      )}
    </>
  )
}

export default BatterDataRow
